var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87501 3.54307C3.68039 3.54307 2.71195 4.5115 2.71195 5.70613C2.71195 6.90075 3.68039 7.86918 4.87501 7.86918C6.06963 7.86918 7.03806 6.90075 7.03806 5.70613C7.03806 4.5115 6.06963 3.54307 4.87501 3.54307ZM1.6214 5.70613C1.6214 3.90921 3.07809 2.45251 4.87501 2.45251C6.67193 2.45251 8.12862 3.90921 8.12862 5.70613C8.12862 7.50305 6.67193 8.95974 4.87501 8.95974C3.07809 8.95974 1.6214 7.50305 1.6214 5.70613Z",
    fill: "#17253F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87501 11.6681C3.68039 11.6681 2.71195 12.6365 2.71195 13.8311C2.71195 15.0257 3.68039 15.9942 4.87501 15.9942C6.06963 15.9942 7.03806 15.0257 7.03806 13.8311C7.03806 12.6365 6.06963 11.6681 4.87501 11.6681ZM1.6214 13.8311C1.6214 12.0342 3.07809 10.5775 4.87501 10.5775C6.67193 10.5775 8.12862 12.0342 8.12862 13.8311C8.12862 15.628 6.67193 17.0847 4.87501 17.0847C3.07809 17.0847 1.6214 15.628 1.6214 13.8311Z",
    fill: "#17253F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87501 19.7931C3.68039 19.7931 2.71195 20.7615 2.71195 21.9561C2.71195 23.1507 3.68039 24.1192 4.87501 24.1192C6.06963 24.1192 7.03806 23.1507 7.03806 21.9561C7.03806 20.7615 6.06963 19.7931 4.87501 19.7931ZM1.6214 21.9561C1.6214 20.1592 3.07809 18.7025 4.87501 18.7025C6.67193 18.7025 8.12862 20.1592 8.12862 21.9561C8.12862 23.753 6.67193 25.2097 4.87501 25.2097C3.07809 25.2097 1.6214 23.753 1.6214 21.9561Z",
    fill: "#17253F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2917 6.25144H9.75V5.16089H23.2917V6.25144Z",
    fill: "#17253F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2917 14.3764H9.75V13.2859H23.2917V14.3764Z",
    fill: "#17253F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2917 22.5014H9.75V21.4109H23.2917V22.5014Z",
    fill: "#17253F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logs.68431957ec66de7820056799d8f418c4.svg";